/**
 * WebSocket URL for real-time events (§3 API spec).
 * Uses same origin as REST API (VITE_API_URL or current origin).
 * Malformed VITE_API_URL must not throw — otherwise the WS effect crashes the app after login.
 */
export function getWebSocketUrl(): string {
  const baseRaw = import.meta.env.VITE_API_URL;
  const base = typeof baseRaw === "string" ? baseRaw.trim() : "";

  let origin: string;
  try {
    if (base) {
      origin = new URL(base).origin;
    } else if (typeof window !== "undefined") {
      origin = window.location.origin;
    } else {
      origin = "http://localhost";
    }
  } catch {
    origin = typeof window !== "undefined" ? window.location.origin : "http://localhost";
  }

  const protocol = origin.startsWith("https") ? "wss" : "ws";
  let host: string;
  try {
    host = new URL(origin).host;
  } catch {
    host = typeof window !== "undefined" ? window.location.host : "localhost";
  }
  return `${protocol}://${host}/ws`;
}
